import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input, output, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { AnimationOption, SocialWallModel } from '../../../common/models';

const DESKTOP_POST_COUNT = 12;
const MOBILE_POST_COUNT = 3;
const MOBILE_VIEWPORT_QUERY = '(max-width: 639px)';

@Component({
  selector: 'lib-social-wall-widget',
  templateUrl: './social-wall-widget.component.html',
  styleUrl: './social-wall-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SocialWallWidgetComponent {

  public title = input<string | null>(null);
  public channelList = input<SocialWallModel[] | null>(null);
  public animation = input<AnimationOption>();
  public animationDelay = input(0);

  public seeAllPosts = output<string>();

  public selectedChannel = signal<SocialWallModel | null>(null);

  private readonly breakpointObserver = inject(BreakpointObserver);

  private readonly isMobileViewport = toSignal(
    this.breakpointObserver.observe(MOBILE_VIEWPORT_QUERY).pipe(map(result => result.matches)),
    { initialValue: this.breakpointObserver.isMatched(MOBILE_VIEWPORT_QUERY) }
  );

  public postCount = computed(() => this.isMobileViewport() ? MOBILE_POST_COUNT : DESKTOP_POST_COUNT);

  constructor() {
    effect(() => {
      const channels = this.channelList();

      if (channels?.length) {
        this.selectedChannel.set(channels[0]);
      }
    });
  }

  public selectChannel(channel: SocialWallModel): void {
    this.selectedChannel.set(channel);
  }

}
